import {EmployeeSelector} from "./component/employeeAutocompleate/employeeSelector";
import {AutocompleteModuleConfiguration} from "./EmployeeAutocompleteModuleConfiguration";
import {
    SingleEmployeeAutocompleteComponent
} from "./component/single-employee-autocomplete/single-employee-autocomplete.component";

AutocompleteModuleConfiguration
    .createNewModule()
    .component('employeeSelector', EmployeeSelector.instance)
    .component('singleEmployeeSelector', SingleEmployeeAutocompleteComponent.instance);